import * as React from "react";
import { Input } from "antd";
import { observer } from "mobx-react-lite";
import { TextAreaProps } from "antd/lib/input";
import { CellInternalBox } from "./CellInternalBox";
import { PropsCell2Editor } from "../PropsCell2";

export const Cell2Text: React.FC<PropsCell2Editor<TextAreaProps>> = observer(
  ({ cell, editorProps }) => {
    const { store, value, ...cellProps } = cell;
    const { cellKey } = cell;
    // const iref = React.useRef<TextAreaRef>(null);

    // Не получилось использовать антовский TextAreaRef
    // Потому что у него оказалось какое-то неподхлдящее поведение и отсутствует select (см LPLM-5264)
    // Поэтому используется поиск через DOM нужного элемента textarea. С ним всё работает нормально.
    const divRef = React.useRef<HTMLDivElement>(null);
    const getTxElement = (): HTMLTextAreaElement | null | undefined =>
      divRef.current?.querySelector("textarea");

    React.useEffect(() => {
      store.updateCell({
        ...cellProps,
        focus(select: boolean) {
          const tx = getTxElement();
          tx?.focus?.();
          if (select) tx?.select?.();
        },
        blur() {
          getTxElement()?.blur?.();
        },
      });
    });

    React.useEffect(() => {
      store.setSrcCellValue(cellKey, value);
    }, [value]);
    const inView = store.isViewMode(cellKey);
    const errMsg = store.errors[cellKey];
    return (
      <CellInternalBox store={store} cellKey={cellKey} pos={cell.pos}>
        <div ref={divRef} style={{ flex: 1 }}>
          <Input.TextArea
            {...editorProps}
            status={errMsg ? "error" : undefined}
            value={String(store.cellCurValues[cellKey] ?? "")}
            onChange={(e) =>
              store.setCurCellValue(cellKey, e.currentTarget.value)
            }
            style={{ width: "100%" }}
            readOnly={inView}
            onFocus={(e) => {
              store.activate(cellKey, false);
              editorProps.onFocus?.(e);
            }}
            onBlur={() => {
              store.blur(store.cellByKey(cellKey));
            }}
            onClick={() => {
              store.activate(cellKey, false);
            }}
            onDoubleClick={() => {
              store.activate(cellKey, true);
            }}
            onKeyDown={(e) => {
              if (e.code === "Enter") {
                // В режиме редактирования Enter используется для создания новой строки
                // Вместо него можно использовать Ctrl+Enter
                if (store.editing && !e.ctrlKey) return;
              }
              store.onKeyDown(cellKey, e);
            }}
          />
        </div>
      </CellInternalBox>
    );
  },
);
